<template>
  <div>
    <el-collapse v-model="activeName" @change="changeColl" accordion>
      <slot></slot>
    </el-collapse>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      titleList: {
        type: Array,
        default() {
          return []
        }
      },
      sCollActiveName: {
        type: String,
        default: '1'
      }
    },
    computed: {},
    created() {
      this.activeName = this.sCollActiveName
    },
    mounted() {
      setTimeout(() => {
      }, 50)
      window.addEventListener('resize', () => {
        setTimeout(() => {
        }, 50)
      })
    },
    methods: {
      changeColl(val) {
        this.$emit('changeColl', val)
      }
    },
    data() {
      return {
        activeName: '1'
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable.styl'

</style>



// WEBPACK FOOTER //
// collapse.vue?03db358b